import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IProvider, IProviderPage } from '../models/provider.model';
import { Observable } from 'rxjs';
import { GlobalConfigService } from './global-config.service';

@Injectable({
  providedIn: 'root'
})
export class ProviderService {
  private get baseUrl(): string {
    return this.globalConfig.getApiUrl() + '/providers';
  }

  constructor(
    private http: HttpClient,
    private globalConfig: GlobalConfigService
  ) { }


  listProviders(pageNumber: number, pageSize: number, orderBy: string, sortBy: string, search: string = ''): Observable<IProviderPage> {
    const params: any = {
      pageNumber,
      pageSize,
      orderBy,
      sortBy
    };

    if (search && search.trim() !== '') {
      params.search = search;
    }

    return this.http.get<any>(`${this.baseUrl}`, { params });
  }

  createProvider(provider: IProvider): Observable<IProvider> {
    return this.http.post<IProvider>(`${this.baseUrl}`, provider);
  }

  getProviderById(providerId: string): Observable<IProvider> {
    return this.http.get<IProvider>(`${this.baseUrl}/${providerId}`);
  }

  updateProvider(id: String, provider: IProvider): Observable<IProvider> {
    return this.http.put<IProvider>(`${this.baseUrl}/${id}`, provider);
  }

  deleteProvider(providerId: string): Observable<any> {
    return this.http.delete<any>(`${this.baseUrl}/${providerId}`);
  }
}
